"use strict";

exports.__esModule = true;
exports.setWixData = exports.setWixDataFailure = exports.setWixDataSuccess = exports.setWixDataRequest = exports.SET_WIX_DATA_FAILURE = exports.SET_WIX_DATA_SUCCESS = exports.SET_WIX_DATA_REQUEST = void 0;

var _createAction = _interopRequireDefault(require("../../services/create-action"));

var _wixData = require("../../services/wix-data");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SET_WIX_DATA_REQUEST = 'wixData/SET_REQUEST';
exports.SET_WIX_DATA_REQUEST = SET_WIX_DATA_REQUEST;
var SET_WIX_DATA_SUCCESS = 'wixData/SET_SUCCESS';
exports.SET_WIX_DATA_SUCCESS = SET_WIX_DATA_SUCCESS;
var SET_WIX_DATA_FAILURE = 'wixData/SET_FAILURE';
exports.SET_WIX_DATA_FAILURE = SET_WIX_DATA_FAILURE;
var setWixDataRequest = (0, _createAction["default"])(SET_WIX_DATA_REQUEST);
exports.setWixDataRequest = setWixDataRequest;
var setWixDataSuccess = (0, _createAction["default"])(SET_WIX_DATA_SUCCESS);
exports.setWixDataSuccess = setWixDataSuccess;
var setWixDataFailure = (0, _createAction["default"])(SET_WIX_DATA_FAILURE);
exports.setWixDataFailure = setWixDataFailure;

var setWixData = function setWixData(key, value) {
  return function (dispatch) {
    var _setWixDataRequest;

    dispatch(setWixDataRequest((_setWixDataRequest = {}, _setWixDataRequest[key] = value, _setWixDataRequest)));
    return (0, _wixData.setValue)(key, value).then(function (response) {
      return dispatch(setWixDataSuccess(response));
    })["catch"](function (error) {
      return dispatch(setWixDataFailure(error));
    });
  };
};

exports.setWixData = setWixData;